namespace advisorop.components.identity {

    interface IForgotPasswordFormController {

        forgotPasswordModel: domains.identity.IForgotPasswordModel;

        forgotPassword(isFormValid: boolean): void;

        $router;
    }

    class ForgotPasswordFormController implements IForgotPasswordFormController {

        forgotPasswordModel: domains.identity.IForgotPasswordModel;
        $router;

        resettingPassword = false;
        resetSuccess = false;
        
        constructor(private identityService: services.IdentityService) {

            this.forgotPasswordModel = new domains.identity.ForgotPasswordModel();

        }

        forgotPassword(isFormValid: boolean): void {

            if (!isFormValid) {
                toastr.error("Please input all required fields.");
                return;
            }

            var r = this.$router;

            this.resettingPassword = true;

            this.identityService.forgotPassword(this.forgotPasswordModel)
                .then(data => {
                    toastr.success("Password recovery request successfully posted. Please check your email and click on the password recovery link.");

                    this.resetSuccess = true;

                    setTimeout(() => {
                        r.parent.navigate(["Login"]);
                    }, 2000);

                }, resp => {
                    toastr.error("Error " + resp.status + " " + resp.data);
                }).finally(() => {
                    this.resettingPassword = false;
                });
        }
        

        $onInit(): void {
        }
    }



    class ForgotPasswordForm implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public host: any;

        constructor() {
            this.bindings = {
                //textBinding: '@',
                $router: '<',
                //functionBinding: '&'
            };
            this.controller = ["identityService", ForgotPasswordFormController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/identity-module/components/forgot-password-form.html';
        }

    }
    angular.module(Constants.APP).component("forgotPasswordForm", new ForgotPasswordForm());
}